import { Subject, BehaviorSubject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    updateChannel = new Subject()
    employeeChannel = new Subject();
    positionChannel = new Subject();
    individualCriteriaChannel = new Subject();
    checkExistingSkpChannel = new BehaviorSubject(apiResponse.default);
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.updateChannel.next({status: apiResponse.INITIAL})
        this.employeeChannel.next({status: apiResponse.INITIAL})
        this.positionChannel.next({status: apiResponse.INITIAL})
        this.individualCriteriaChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }

    fetchUpdate = async (query) => {
        try {
            this.updateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }

    fetchEmployee = async (query) => {
        try {
            this.employeeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployee(query).then((result) => {
                this.employeeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.employeeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }
    fetchIndividualCriteria = async (query) => {
        try {
            this.individualCriteriaChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchIndividualCriteria(query).then((result) => {
                this.individualCriteriaChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.individualCriteriaChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

    fetchCreatepernip = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreatepernip(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }

    fetchPosition = async (query) => {
        try {
            this.positionChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchPosition(query).then((result) => {
                this.positionChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.positionChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

    fetchCheckExistingSkp = async (query) => {
        try {
            this.checkExistingSkpChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCheckExistingSkp(query).then((result) => {
                this.checkExistingSkpChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkExistingSkpChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

}

export default CreateBloc